
import React from 'react';

export default function SocialButtons() {
  return (
    <ul className="social-buttons flex justify-center items-center p-4">
      <li className="social-btn">
        <a 
          href="https://discord.com/invite/rPJeDhgMjg" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="social-link discord" 
          aria-label="Rejoindre notre serveur Discord"
        >
          <img 
            src="https://horizons-cdn.hostinger.com/257434f3-17c6-40ce-944a-86edaf1db41d/6befbc7ba19f7e66be8690ab3d8d11a5.png" 
            alt="Discord Logo" 
          />
        </a>
      </li>
    </ul>
  );
}
